module.exports = __webpack_public_path__ + "media/images/technology/MGISEQ-2000-e97c6b6e3e476a32120b04687da29734.png";